import React from "react";
import { connect } from "react-redux";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import { Button, FontIcon } from "react-md";
import { map, isEmpty, size } from "lodash";

import Carousel from "../Carousel";
import AtollonLogo from "../../assets/img/atollon-thumb.png";
import {ADD_HOST_CATEGORIES_FORM_NAME} from "../../Atollon/pages/HostCategories/shared";
import {TouchOrganizations} from "../../Atollon/Organizations";
import {TouchGreyBackgroundWithBorder, TouchTableHeader} from "../../AtollonTheme/ReactElements";
import Translate from "../../Atollon/Translation";

const Organizations = ({ history, organizations }) => {
  return (
    <div>

        <TouchTableHeader
            title={"Moje organizace"}
            titleNumber={organizations && !isEmpty( organizations.item ) ? size( organizations.item ) : null}
            titleButtons={(
                <Button
                    raised
                    className="btn btn-primary touchButton-4 touchButton-shape3"
                    label="Nastavit novou organizaci"
                    onClick={() => history.push("/organization-new")}
                />
            )}
        />

        <TouchGreyBackgroundWithBorder>
        {organizations && !isEmpty( organizations.item ) ?
            <div>
                <TouchOrganizations
                    gotoAdminPage={false}
                    organizationArray={organizations.item}
                    history={history}
                />
            </div>
            : null
        }
        </TouchGreyBackgroundWithBorder>
    </div>
  );
};

export default connect(
  ({ resource: { organizations } }) => ({ organizations }),
  null
)(Organizations);



// WEBPACK FOOTER //
// ./src/components/main/Organizations.js